module.exports = __webpack_public_path__ + "static/media/undelete.dde4c1c0.svg";